import _ from "lodash";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useLogin from "../../custom-hooks/useLogin";
import { useEffect, useState } from "react";
import { getCategoryListNew } from "../../redux/courses/actions";
import { SessionKeys } from "../../utils/AppUtils";
import { select } from "redux-saga/effects";
import axios from "axios";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import { useTranslation } from "react-i18next";

const FilterAndSearchSection = (props) => {
  const { t } = useTranslation();
  const { isLoggedIn } = useLogin();
  const {
    sectionType,
    entityType,
    searchedOrNot,
    setsearchedOrNot,
    searchText,
    setSearchText,
    filterOption,
    setFilterBy,
    filterBy,
    sortOption,
    setSortBy,
    sortBy,
    isFilterShow,
    setSelectedIds,
    isLoading,
    tabKey,
    selectedPartner,
  } = props;

  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  let allPartners = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    allPartners = paramsReq?.allPartners;
  }
  // const [selectedPartner, setSelectedPartner] = useState(
  //   providerId ? "" : "all"
  // );
  // const providerId = params.get("provider_id");

  const authBroker = useSelector((state) => state.auth.authBroker);
  const categoryListNewRes = useSelector(
    (state) => state.courses.categoryListNewRes
  );

  const [courseCategories, setCourseCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isCatLoading, setIsCatLoading] = useState(false);
  const [content, setContent] = useState({
    course: "",
    video: "",
    learningpath: "",
    coaching: "",
  });

  const textLocal = localStorage.getItem(SessionKeys.DYNAMIC_CONTENT);

  useEffect(() => {
    const storedData = localStorage.getItem(SessionKeys.DYNAMIC_CONTENT);
    if (storedData) {
      setContent(JSON.parse(storedData));
    }
  }, [textLocal]);

  console.log("content", content);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);

  useEffect(() => {
    categoriesListReq();
  }, [selectedPartner, activeLanguage]); //sectionType,searchedOrNot,filterBy,selectedPartner

  const categoriesListReq = (filterValue = filterBy) => {
    setCourseCategories([]);
    setSubCategories([]);
    console.log("isLoggedIn: ", isLoggedIn, sectionType);

    let req = {
      entity_type: entityType, // course or video
      section_type: sectionType,
      provider_id: providerId
        ? providerId
        : selectedPartner != "all"
        ? selectedPartner
        : "",
      popular_tab: tabKey === "popular" ? true : false,
      new_tab:
        tabKey === "NewCourses" || tabKey === "new-videos" ? true : false,
      search: searchText,
      popular_days: tabKey === "popular" ? filterValue : "",
      isAll: allPartners ? (selectedPartner != "all" ? false : true) : false,
      language: activeLanguage ? activeLanguage : "",
    };

    if (
      (entityType === "course" && tabKey === "AllCourses") ||
      (entityType === "video" && (tabKey === "all" || tabKey === "popular"))
    ) {
      req.filter = tabKey === "popular" ? 1 : filterValue;
    }

    if (
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) === null ||
      _.isEmpty(localStorage.getItem(SessionKeys.API_TOKEN_BROKER))
    ) {
      req.token = "";
    } else {
      req.token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
      // dispatch(
      //   getCategoryListNew({
      //     module: "getCategoryListingNew",
      //     postData: req,
      //   })
      // );
    }

    //this need to be change in redux method
    axios({
      method: "post",
      url: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_CATEGORY_LIST_NEW_END_POINT}`,
      data: req,
      header: { "Content-Type": "application/json" },
    })
      .then((response) => {
        console.log("RESPONSERemind", response);
        if (response.data.status) {
          let categoryArray = [];
          if (response.data.data.length > 0) {
            categoryArray = _.cloneDeep(response.data.data);
          }
          for (const item of categoryArray) {
            item.isChecked = false;
            for (const subItem of item.sub_categories) {
              subItem.parentId = item.categoryId;
              subItem.isChecked = false;
            }
          }

          console.log("product categories4", categoryArray, searchText);
          setCourseCategories(categoryArray);
        } else {
          // setShowModalMsg("Error in sending req.");
        }
        // setConfirmModal(true);
      })
      .catch((error) => {
        // setConfirmModal(true);
        // setShowModalMsg("Error in sending req.");
      });
  };

  useEffect(() => {
    return;
    if (!_.isEmpty(categoryListNewRes)) {
      if (categoryListNewRes.status === "success") {
        let categoryArray = [];
        if (categoryListNewRes.payload.payload.length > 0) {
          categoryArray = categoryListNewRes.payload.payload;
        }
        for (const item of categoryArray) {
          item.isChecked = false;
          for (const subItem of item.sub_categories) {
            subItem.parentId = item.categoryId;
            subItem.isChecked = false;
          }
        }
        console.log("product categories1", categoryArray);
        setCourseCategories(categoryArray);
      }
    }
  }, [categoryListNewRes]);

  const [selectedCategory, setSelectedCategory] = useState([]);

  useEffect(() => {
    console.log("selected cat--", courseCategories, subCategories);
    let tempIdsArr = [];
    for (let index = 0; index < courseCategories.length; index++) {
      const element = courseCategories[index];
      if (element.isChecked) {
        tempIdsArr.push(element.categoryId);
      }
    }

    const allUnchecked = subCategories.every((item) => !item.isChecked);
    if (allUnchecked) {
      // let uncheckedItemIds = subCategories.map((item) => item.categoryId);
      // tempIdsArr.push(...uncheckedItemIds);
    } else {
      for (let index = 0; index < subCategories.length; index++) {
        const element = subCategories[index];
        if (element.isChecked) {
          tempIdsArr.push(element.categoryId);
        }
      }

      //for insertion ids those subcategory is not selected but categories is selected
      // for (let index = 0; index < courseCategories.length; index++) {
      //   const element = courseCategories[index];
      //   if (element.isChecked) {
      //     let isAllSubCatUnCheckedWithCat = true;
      //     for (let index = 0; index < subCategories.length; index++) {
      //       const element1 = subCategories[index];
      //       if (
      //         element1.parentId === element.categoryId &&
      //         element1.isChecked
      //       ) {
      //         isAllSubCatUnCheckedWithCat = false;
      //       }
      //     }
      //     if (isAllSubCatUnCheckedWithCat) {
      //       for (
      //         let index = 0;
      //         index < element.sub_categories.length;
      //         index++
      //       ) {
      //         const element3 = element.sub_categories[index];
      //         tempIdsArr.push(element3.categoryId);
      //       }
      //     }
      //   }
      // }
    }

    console.log("tempIdsArr: ", tempIdsArr);
    tempIdsArr = [...new Set(tempIdsArr)];
    setSelectedIds(tempIdsArr);
  }, [courseCategories, subCategories]);

  const removeSubCatRelatedToCat = (catId) => {
    let tempArr = [];
    for (let index = 0; index < subCategories.length; index++) {
      const element = subCategories[index];
      if (element.parentId !== catId) {
        tempArr.push(element);
      }
    }
    setSubCategories(tempArr);
  };

  const handleRemoveCategory = (categoryIdToRemove) => {
    // Use the filter method to create a new array excluding the category with the specified ID
    const updatedList = selectedCategory.filter(
      (category) => category.categoryId !== categoryIdToRemove
    );

    // Update the state with the new array
    setSelectedCategory(updatedList);
  };

  useEffect(() => {
    console.log("check final", selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
    if (searchText === "") {
      setSelectedIds(["1"]);
      setSelectedIds([]);
      setsearchedOrNot(!searchedOrNot);
    }
    return () => {};
  }, [searchText]);

  return (
    <>
      {(entityType === "course" || entityType === "video") && false &&
        localStorage.getItem(SessionKeys.SHOW_LEADERBOARD) !== "false" &&
        content?.course && (
          <div className="mt-4">
            <div className="xsel-focus-box">{content?.course}</div>
          </div>
        )}
      <div className="filter-section">
        <div className="d-sm-flex justify-content-sm-between">
          <div className="search-section-listing">
            {
              <div className="confirm-row">
                <input
                  type="search"
                  className="form-control"
                  id="inputPassword2"
                  placeholder={`${t("Search for")} ${entityType}...`}
                  onChange={(evt) => {
                    console.log("searchData: ", evt.target.value);
                    if (_.isEmpty(evt.target.value)) {
                      setSearchText("");
                    } else {
                      setSearchText(evt.target.value);
                    }
                  }}
                  disabled={isLoading}
                />
                <button
                  className={`confirm-btn ${
                    searchText === "" ? "cursor-not-allowed" : ""
                  }`}
                  onClick={() => {
                    if (searchText === "") {
                    } else {
                      setSelectedIds(["1"]);
                      setSelectedIds([]);
                      categoriesListReq();
                      setsearchedOrNot(!searchedOrNot);
                    }
                  }}
                  disabled={isLoading}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                      fill="black"
                    />
                  </svg>
                  {t("Search")}
                </button>
              </div>
            }
          </div>
          <div className="filter-option-listing d-flex justify-content-end">
            {isFilterShow && (
              <Dropdown
                className="filter-btn"
                onSelect={(e) => {
                  setFilterBy(_.toNumber(e));
                  categoriesListReq(_.toNumber(e));
                }}
              >
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.16666 10C4.16666 9.53978 4.53975 9.16669 4.99999 9.16669H15C15.4602 9.16669 15.8333 9.53978 15.8333 10C15.8333 10.4603 15.4602 10.8334 15 10.8334H4.99999C4.53975 10.8334 4.16666 10.4603 4.16666 10Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.66666 5.00002C1.66666 4.53978 2.03975 4.16669 2.49999 4.16669H17.5C17.9602 4.16669 18.3333 4.53978 18.3333 5.00002C18.3333 5.46026 17.9602 5.83335 17.5 5.83335H2.49999C2.03975 5.83335 1.66666 5.46026 1.66666 5.00002Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.66666 15C6.66666 14.5398 7.03975 14.1667 7.49999 14.1667H12.5C12.9602 14.1667 13.3333 14.5398 13.3333 15C13.3333 15.4603 12.9602 15.8334 12.5 15.8334H7.49999C7.03975 15.8334 6.66666 15.4603 6.66666 15Z"
                      fill="#415385"
                    />
                  </svg>
                  {t("Filter")}
                </Dropdown.Toggle>
                <Dropdown.Menu className="drop-down-menu">
                  {!_.isEmpty(filterOption) &&
                    filterOption.map((s, i) => {
                      return (
                        <Dropdown.Item
                          className={`dropdown-menu-item ${
                            filterBy == s.value ? "active" : ""
                          }`}
                          key={`filter-${i + 1}`}
                          eventKey={s.value}
                        >
                          {s.label}
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              </Dropdown>
            )}
            {
              <Dropdown
                className="filter-btn"
                onSelect={(e) => {
                  setSortBy(_.toNumber(e));
                }}
              >
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.16666 10C4.16666 9.53978 4.53975 9.16669 4.99999 9.16669H15C15.4602 9.16669 15.8333 9.53978 15.8333 10C15.8333 10.4603 15.4602 10.8334 15 10.8334H4.99999C4.53975 10.8334 4.16666 10.4603 4.16666 10Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.66666 5.00002C1.66666 4.53978 2.03975 4.16669 2.49999 4.16669H17.5C17.9602 4.16669 18.3333 4.53978 18.3333 5.00002C18.3333 5.46026 17.9602 5.83335 17.5 5.83335H2.49999C2.03975 5.83335 1.66666 5.46026 1.66666 5.00002Z"
                      fill="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.66666 15C6.66666 14.5398 7.03975 14.1667 7.49999 14.1667H12.5C12.9602 14.1667 13.3333 14.5398 13.3333 15C13.3333 15.4603 12.9602 15.8334 12.5 15.8334H7.49999C7.03975 15.8334 6.66666 15.4603 6.66666 15Z"
                      fill="#415385"
                    />
                  </svg>
                  {t("Sort")}
                </Dropdown.Toggle>
                <Dropdown.Menu className="drop-down-menu">
                  {!_.isEmpty(sortOption) &&
                    sortOption.map((s, i) => {
                      return (
                        <Dropdown.Item
                          className={`dropdown-menu-item ${
                            sortBy == s.value ? "active" : ""
                          }`}
                          key={`sort-${i + 1}`}
                          eventKey={s.value}
                        >
                          {s.label}
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              </Dropdown>
            }
          </div>
        </div>

        <div id="idCategoryList" className="filter-section">
          <div className="customcheck-row">
            {courseCategories?.length > 0 &&
              courseCategories.map((item, index) => {
                return (
                  <div className="form-check customcheck">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={item.isChecked}
                      id="flexCheckDefault"
                      onChange={(ev) => {
                        let tempArr = _.cloneDeep(courseCategories);
                        tempArr[index].isChecked = ev.target.checked;
                        setCourseCategories(tempArr);
                        console.log(
                          "cat--",
                          tempArr,
                          "sub cat--",
                          subCategories
                        );
                        if (ev.target.checked) {
                          let subCatTemp = _.cloneDeep(subCategories);
                          for (const subItem of tempArr[index].sub_categories) {
                            subItem.isChecked = false;
                          }
                          setSubCategories([
                            ...subCatTemp,
                            ...tempArr[index].sub_categories,
                          ]);

                          let subCats = [
                            ...subCatTemp,
                            ...tempArr[index].sub_categories,
                          ];

                          item.sub_categories.forEach((subCategory) => {
                            // Check if the id exists in subCategories list
                            if (subCats.includes(subCategory.id)) {
                              // If yes, set isCheck to true
                              subCategory.isChecked = true;
                            } else {
                              // Otherwise, set isCheck to false
                              subCategory.isChecked = false;
                            }
                          });
                          console.log("check1", selectedCategory, item);
                          setSelectedCategory([...selectedCategory, item]);
                        } else {
                          handleRemoveCategory(item.categoryId);
                          removeSubCatRelatedToCat(item.categoryId);
                        }
                      }}
                      disabled={isLoading}
                    />
                    <label className="form-check-label">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item?.categoryName,
                        }}
                      ></span>
                    </label>
                  </div>
                );
              })}
          </div>

          <div className="customcheck-row sub-dot">
            {subCategories?.map((item, index) => {
              return (
                <div
                  className="customcheck-dot"
                  onClick={() => {
                    if (isLoading) {
                      return;
                    }

                    let tempArr = _.cloneDeep(subCategories);
                    if (tempArr[index].isChecked)
                      tempArr[index].isChecked = false;
                    else tempArr[index].isChecked = true;
                    setSubCategories(tempArr);
                    console.log("check cat---", tempArr, selectedCategory);
                    selectedCategory.map((selectedCategor) => {
                      if (selectedCategor?.sub_categories) {
                        selectedCategor?.sub_categories.forEach(
                          (subCategory) => {
                            // Check if the id exists in subCategories list
                            if (
                              tempArr[index].categoryId ===
                                subCategory.categoryId &&
                              tempArr[index].isChecked
                            ) {
                              // If yes, set isCheck to true
                              subCategory.isChecked = true;
                            } else {
                              // Otherwise, set isCheck to false
                              subCategory.isChecked = false;
                            }
                          }
                        );
                      }
                    });
                    console.log("cat---1", selectedCategory?.sub_categories);
                    setSelectedCategory(selectedCategory);
                  }}
                >
                  <div
                    className={item.isChecked ? "chipbar-selected" : "chipbar"}
                  >
                    {
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item?.categoryName,
                        }}
                      ></span>
                    }
                    {item.isChecked && (
                      <img src="/images/phip-close-icon.svg" alt="" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
export default FilterAndSearchSection;
